import { EyWorksDatePicker } from 'eyworks-ui-components';
import React, { useState } from 'react';
import { CustomButton, CustomImageView, CustomTextInput } from 'src/app/components';
import BackButtonLayout from 'src/app/layouts/BackButtonLayout';
import { AiOutlinePlusCircle } from "react-icons/ai";

const AddObservation = () => {
   
    return (
        <BackButtonLayout title='Add Observation'>
            <div className='flex-1'>
                <div className='row'>
                    <div className='col-6 mg-t-25'>
                        <div className='form-group'>
                            <div className='fs-12 text-gray-300 mg-b-5'>Date:</div>
                            <EyWorksDatePicker
                                customDateValue={'Not Set'}
                                onChange={() => {}}
                            />
                        </div>
                    </div>
                    <div className='col-6 mg-t-25'>
                        <div className='form-group'>
                            <div className='fs-12 text-gray-300 mg-b-5'>Time:</div>
                            <EyWorksDatePicker
                                customDateValue={'Not Set'}
                                onChange={() => {}}
                            />
                        </div>
                    </div>
                </div>
                <div className='mg-t-25'>
                    <CustomTextInput label='Observation' name="message" type='message' value='' onChange={() => {}} multiline={true} asterisk={true} />
                </div>
                <div className='mg-t-25'>
                    <div className='fs-12 text-gray-300'>Add Media</div>
                    <div className='d-flex flex-wrap mx-n-8'>
                        <div className='pd-x-8 mg-t-15'>
                            <div className='rounded-3 border border-gray-700 bg-white-300 media-item d-flex align-items-center justify-content-center cursor-pointer'><AiOutlinePlusCircle size={23} /></div>
                        </div>
                        <div className='pd-x-8 mg-t-15'>
                            <CustomImageView 
                                url={'https://img.risingkashmir.com/wp-content/uploads/2024/07/Image-OP-2-4-860x533.png'}
                                showCancelBtn={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='mg-t-25'>
                <CustomButton text='Save' onClick={() => {}} color='primary' />
            </div>
            
        </BackButtonLayout>
    )
}

export default AddObservation;